export class ItiCoreAPI {

    protected webApiBase = 'falta llamar a ItiCoreAPI.setWebApiBase()';

    //#region Scheduled Task
    public get scheduledTasks() {
        return this.webApiBase + 'ScheduledTasks';
    }
    public get scheduledTask() {
        return this.scheduledTasks + '/{0}';
    }

    public get scheduledTaskStart() {
        return this.scheduledTask + '/Start';
    }
    public get scheduledTaskStop() {
        return this.scheduledTask + '/Stop';
    }
    //#endregion

    public setWebApiBase(webApiBase: string) {
        this.webApiBase = webApiBase;
    }

}

export default new ItiCoreAPI();
